import React, { useEffect, useState } from "react";
import { replace, useNavigate, useParams } from "react-router-dom";
import tournamentsTeamsService from "../../services/tournamentsTeams";
import errorHandler from "../../utils/errorHandler";
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Tooltip,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Loader } from "../../components/CustomLoader";
import DataTable from "react-data-table-component";
import { Helmet } from "react-helmet-async";
import CardLayout from "../../layouts/CardLayout";
import { IMAGE_BASE } from "../../utils/constants";
import { ImageCell } from "../../components/FetchImage";
import tournamentsService from "../../services/tournaments";
import { EditOutlined } from "@mui/icons-material";

const TournamentTeamsList = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [data, setData] = useState([]);
  const [team, setteam] = useState("");
  const [totalPages, setTotalPages] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await tournamentsTeamsService.getAllTournamantTeams({
          id,
        });

        setData(response?.data?.data?.teams);
        setteam(response?.data?.data?.tournament);

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  const columns = [
    {
      name: "S.No.",
      width: "80px",
      center: true,
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "120px",
    },

    {
      name: "Short Name",
      selector: (row) => row.short_name,
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "120px",
    },
    {
      name: "Country",
      selector: (row) => row.country_name || "NA",
      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "160px",
      cell: (row) => {
        const imageUrl = `public/${row.country_image}`;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {row.country_image ? (
              <ImageCell
                logo_url={imageUrl}
                alt={row.country_name}
                width={24}
                height={16}
              />
            ) : (
              <span>No Image</span>
            )}
            <span>{row.country_name || "NA"}</span>
          </div>
        );
      },
    },

    {
      name: "image",

      sortable: true,
      grow: 2,
      wrap: true,
      minWidth: "120px",
      cell: (row) =>
        row.logo_url ? (
          <ImageCell logo_url={row.logo_url} width={40} height={40} />
        ) : (
          <span>No Image</span>
        ),
    },

    {
      name: "Action",
      center: true,
      grow: 1,
      minWidth: "160px",
      cell: (row) => (
        <>
          <Tooltip title="View" placement="top">
            <IconButton
              sx={{ color: "#8A63A9" }}
              color="primary"
              onClick={() => {
                navigate(`/tournaments/view/${row.id}`, { replace: true });
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit" placement="top">
            <IconButton
              sx={{ color: "#8A63A9" }}
              color="primary"
              onClick={() => {
                navigate(`/tournaments/edit/${row?.id}`);
              }}
            >
              <EditOutlined />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  console.log("dataa", data);
  return (
    <div>
      <div>
        <CardLayout>
          <Helmet>
            <title>All Teams in Tournaments</title>
          </Helmet>
          <Card>
            <CardHeader
              titleTypographyProps={{ variant: "h4" }}
              title={`Teams in ${team?.name} Season:${team?.season}`}
            />

            <CardContent>
              <DataTable
                customStyles={{
                  headRow: {
                    style: {
                      backgroundColor: "#F3E8FF",
                      minHeight: "50px",
                    },
                  },
                  headCells: {
                    style: {
                      fontSize: "15px",
                      fontWeight: "bold",
                      color: "black",
                    },
                  },
                  rows: {
                    style: {
                      minHeight: "45px",
                      fontSize: "14px",
                      color: "black",
                      backgroundColor: "#FFFFFF",
                    },
                  },
                }}
                columns={columns}
                data={data}
                pagination
                paginationServer
                paginationTotalRows={totalPages}
                paginationPerPage={pageSize}
                paginationRowsPerPageOptions={[10, 20, 50]}
                onChangeRowsPerPage={(currentRowsPerPage) =>
                  setPageSize(currentRowsPerPage)
                }
                progressPending={isLoading}
                progressComponent={<Loader />}
                className="custom"
              />
            </CardContent>
          </Card>
        </CardLayout>
      </div>
    </div>
  );
};

export default TournamentTeamsList;
